import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const { t } = useTranslation();

  return (
    <nav aria-label="breadcrumb" className="w-full px-4 md:px-6 lg:px-8">
      <ol className="flex items-center gap-2 text-sm text-foreground-500 py-4 flex-wrap">
        <li>
          <Link to="/" className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
            {t('breadcrumb.home')}
          </Link>
        </li>
        {items.map((item, idx) => (
          <li key={idx} className="flex items-center gap-2">
            <span className="text-foreground-300">/</span>
            {item.to ? (
              <Link to={item.to} className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}